<template>

    <div class="vx-row">
        <div class="vx-col w-2/3">
            <vs-card>
                <vs-input v-model="name" class="w-full" placeholder="Naam"></vs-input>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Prijs</h5>
                </div>
                <div class="flex">
                    <vs-input icon="euro" v-model="price" class="w-5/6" placeholder="Prijs"></vs-input>
                    <vs-select v-model="vat" class="w-1/6">
                        <vs-select-item v-for="(item, index) in [{label: '9%', value: 9},{label: '21%', value: 21}]" :key="index" :value="item.value" :text="item.label"></vs-select-item>
                    </vs-select>
                </div>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Beschrijving</h5>
                </div>
                <div>
                    <vs-textarea v-model="description" height="250px"></vs-textarea>
                </div>
            </vs-card>
            <vs-card class="mb-4">
                <div slot="header">
                    <h5>Opties</h5>
                </div>
                <div>
                    <vs-checkbox v-model="selectedAddonCategories" multiple v-for="addonCat in addonCategories" :key="addonCat.id" :vs-value="addonCat.id" class="pb-2">
                        {{ addonCat.name }}
                        <div>
                            <small v-for="(addon, index) in addonCat.addons" :key="addon.id">{{ addon.name }}<span v-if="addon.price"> (€{{ addon.price }})</span><span v-if="index !== addonCat.addons.length-1">, </span></small>
                        </div>
                    </vs-checkbox>
                </div>
            </vs-card>
        </div>
        <div class="vx-col w-1/3">
            <vs-button @click="editProduct" class="w-full mb-6">Opslaan</vs-button>
            <vs-card>
                <div slot="header">
                    <h5>Categorie</h5>
                </div>
                <div>
                    <vs-radio v-for="cat in categories" :key="cat.id" class="w-full" :vs-value="cat.id" v-model="category">{{ cat.name }}</vs-radio>
                </div>
            </vs-card>
            <vs-card>
                <div slot="header">
                    <h5>Alcohol</h5>
                </div>
                    <vs-switch v-model="alcohol"></vs-switch>

            </vs-card>
            <vs-card>
                <div slot="header">
                    <h5>Afbeelding</h5>
                </div>
                <div>
                    <vs-upload @change="handleImageUpload" @on-delete="image = null" />
                </div>
            </vs-card>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            position: '',
            vat: 9,
            name: '',
            description: '',
            price: '',
            alcohol: false,
            category: null,
            addonCategories: [],
            selectedAddonCategories: [],
            image: null,
            categories: []
        }
    },
    created() {
        this.getProduct();
        this.getProductCategories();
        this.getProductAddonCategories();
    },
    mounted() {
      this.$events.listen("company-selected", event => {
          this.$router.replace({name: 'companies-products', params: {slug: event.slug}});
      });
    },
    computed: {
        imageUrl: function() {
            if(this.image != null) {
                return URL.createObjectURL(this.image);
            }
        },
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    },
    methods: {
        handleImageUpload(e, f) {
            this.image = f[0];
        },
        getProductCategories() {
            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-categories' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-categories'
            this.$http.get(url, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then((response) => {
              if (this.staffRoute) {
                this.category = response.data.data[0];
                this.categories = response.data.data;
              } else {
                this.category = response.data[0];
                this.categories = response.data;
                console.log(response.data);
              }
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            });
        },
        getProductAddonCategories() {
            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-category-addons' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product-category-addons'
            this.$http.get(url, {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then((response) => {
                this.addonCategories = response.data;
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            });
        },
        getProduct() {
            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product'
            this.$http.get(url, {
                params: {
                    'id': this.$route.params.product
                },
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then((response) => {
                this.position = response.data.position;
                this.vat = response.data.vat;
                this.name = response.data.name;
                this.description = response.data.description;
                this.price = response.data.price;
                this.category = response.data.category.id;
                this.alcohol = response.data.alcohol;
                response.data.addon_categories.map(cat => {
                    this.selectedAddonCategories.push(cat.id)
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            });
        },
        editProduct() {
            let formData = new FormData();

            formData.append('_method', 'PUT');
            formData.append('id', this.$route.params.product);
            formData.append('name', this.name);
            formData.append('description', this.description);
            formData.append('position', this.position);
            formData.append('vat', this.vat);
            formData.append('alcohol', this.alcohol);
            formData.append('image', this.image);
            formData.append('price', this.price);
            formData.append('category', this.category);
            formData.append('addoncategories', JSON.stringify(this.selectedAddonCategories));

            let token = this.staffRoute ? JSON.parse(localStorage.getItem('stafftoken')) : JSON.parse(localStorage.getItem('companytoken'));
            let url = this.staffRoute ? 'https://staffapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product/update' : 'https://companyapi.hebtrek.nl/v1/company/'+ this.$route.params.slug +'/product/update'
            this.$http.post(url, formData,
            {
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                console.log(response)
                this.$router.push({'name': 'companies-products'});
                this.$vs.notify({
                    title: 'Success',
                    text: 'Succesvol opgeslagen',
                    color: 'success'
                });
            }).catch((error) => {
                this.$util.logError(error, this.$vs);
            })

        }
    }
}
</script>

<style>
    .ht-image {
        width: auto;
    }
    .img-upload,
    .con-input-upload {
        width: 100%;
        margin-left: 0px;
        margin-top: 0px;
    }
</style>
